/*
THis is shopify share button code
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
*/

if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();
        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        
        // Find social media links
        this.shareSocialLinks = this.querySelectorAll('.share-button__social-link');
        
        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
        
        // Set up social sharing functionality
        this.setupSocialShareLinks();

        }
      
      setupSocialShareLinks() {
        // Get current page URL and title
        const currentUrl = window.location.href;
        const pageTitle = document.title;
        
        // Update each social share link with current page info
        this.shareSocialLinks.forEach(link => {
          // Update the URL parameter in each social media link
          if (link.classList.contains('share-button__social-link--linkedin')) {
            link.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
          } else if (link.classList.contains('share-button__social-link--twitter')) {
            link.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(currentUrl)}`;
          } else if (link.classList.contains('share-button__social-link--facebook')) {
            link.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
          }
          
          // Add event listener to track shares
          link.addEventListener('click', (event) => {
            // Track the share event (you can add analytics here)
            const platform = link.classList.contains('share-button__social-link--linkedin') ? 'LinkedIn' :
                            link.classList.contains('share-button__social-link--twitter') ? 'Twitter' :
                            link.classList.contains('share-button__social-link--facebook') ? 'Facebook' : 'Unknown';
            
            console.log(`Content shared on ${platform}: ${currentUrl}`);
          });
        });
        
        // Update the input URL field with current page URL if it exists
        if (this.elements.urlInput) {
          this.elements.urlInput.value = currentUrl;
        }
      }
      
      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }
      
      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
        
        // Update social media links with the new URL
        if (this.shareSocialLinks && this.shareSocialLinks.length > 0) {
          const pageTitle = document.title;
          
          this.shareSocialLinks.forEach(link => {
            if (link.classList.contains('share-button__social-link--linkedin')) {
              link.href = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
            } else if (link.classList.contains('share-button__social-link--twitter')) {
              link.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(url)}`;
            } else if (link.classList.contains('share-button__social-link--facebook')) {
              link.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
            }
          });
        }
      }
    }
  );
}

// Ensure the share functionality works for dynamically loaded content
document.addEventListener('DOMContentLoaded', () => {
  // For any share buttons that might be loaded after initial page load
  const refreshShareButtons = () => {
    document.querySelectorAll('share-button:not([initialized])').forEach(button => {
      button.setAttribute('initialized', '');
    });
  };
  
  // Initial call
  refreshShareButtons();
  
  // Set up a mutation observer to detect new share buttons
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        refreshShareButtons();
      }
    });
  });
  
  // Start observing the document body for DOM changes
  observer.observe(document.body, { childList: true, subtree: true });
});